import { AutoDetailsForm } from '@/components/modules/Application/components/Cart/AutoCart/components/AutoDetailsForm';
import { useArticleTypes } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useArticleTypes';
import { useCartItemState } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/hooks/useCartItemState';
import { CartItemDialogFormSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/schemas/CartItemDialogFormSchema';
import { FormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/FormItem';
import { FormWrapper } from '@/components/shared/components/FormWrapper';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const AutoCart = () => {
  const {
    state: { checkoutSessionId },
  } = useApplicationContext();

  const { defaultFormItem } = useArticleTypes();

  const { initialFormItem } = useCartItemState({ items: [defaultFormItem], index: 0 });

  return (
    <div key={`auto-details-${checkoutSessionId}`}>
      <FormWrapper
        formSchema={CartItemDialogFormSchema}
        defaultValues={{
          item: {
            ...initialFormItem,
            isNewVehicle: false,
          } as FormItem,
        }}
      >
        <AutoDetailsForm />
      </FormWrapper>
    </div>
  );
};
